<mat-radio-group [ngModel]="type" (ngModelChange)="typeChange.emit($event)">
    <mat-radio-button value="public">
        {{ "components.room-examination.tariff-categories.public" | translate }}
    </mat-radio-button>
    <mat-radio-button value="private">
        {{ "components.room-examination.tariff-categories.private" | translate }}
    </mat-radio-button>
    <mat-radio-button value="not-determinable">
        {{ "components.room-examination.tariff-categories.not-determinable" | translate }}
    </mat-radio-button>
</mat-radio-group>
@if (type !== 'not-determinable') {
<mat-form-field style="display: block">
    <mat-label>{{ stationLabel | translate }}</mat-label>
    <input matInput [id]="stationInputId" [ngModel]="station" (ngModelChange)="stationChange.emit($event)" />
</mat-form-field>
}